<div class="flex flex-col gap-6">
  <div class="flex items-center">
    <div class="flex flex-col flex-1">
      <h3 class="text-on-surface dark:text-on-surface-darkmode font-semibold">
        {{ 'cockpit.parseRequests.details.general.sectionTitle' | transloco }}
      </h3>
      <p class="text-sm text-on-surface-variant dark:text-on-surface-variant-darkmode">
        {{ 'cockpit.parseRequests.details.general.sectionSubtitle' | transloco }}
      </p>
    </div>
  </div>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 items-center border-t border-surface-highlight dark:border-surface-highlight-darkmode"
  >
    <!-- type -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.parseRequests.details.general.requestTypeLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ 'cockpit.parseRequests.details.general.requestTypeValueDefault' | transloco }}
      </span>
    </div>
    <!-- createdAt -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.parseRequests.details.general.requestDateLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ parseRequest().metadata.createdAt | date: 'dd.MM.yyyy / HH:mm' }}
        {{ 'cockpit.parseRequests.details.general.dateSuffix' | transloco }}
      </span>
    </div>
    <!-- status -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.parseRequests.details.general.statusLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        @switch (parseRequest().status) {
          @case ('OPEN') {
            <ui-badge>
              {{ 'cockpit.parseRequests.status.OPEN' | transloco }}
            </ui-badge>
          }
          @case ('REQUESTED') {
            <ui-badge>
              {{ 'cockpit.parseRequests.status.REQUESTED' | transloco }}
            </ui-badge>
          }
          @case ('IN_PROGRESS') {
            <ui-badge color="primary">
              {{ 'cockpit.parseRequests.status.IN_PROGRESS' | transloco }}
            </ui-badge>
          }
          @case ('DONE') {
            <ui-badge>
              {{ 'cockpit.parseRequests.status.DONE' | transloco }}
            </ui-badge>
          }
        }
      </span>
    </div>
    <!-- businessPartnerName -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.parseRequests.details.general.brokerLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ parseRequest().businessPartnerName }}
      </span>
    </div>
    <!-- unsatisfied -->
    <div
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.parseRequests.details.general.problemsLabel' | transloco }}
    </div>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1 flex gap-1"
      >
        @if (parseRequest().unsatisfied) {
          <ui-badge color="error">
            {{ 'cockpit.parseRequests.details.general.unsatisfiedBadge' | transloco }}
          </ui-badge>
        }
        @switch (parseRequest().unsatisfiedReason) {
          @case ('HIGH_PRICE') {
            {{ 'cockpit.parseRequests.createGeneral.unsatisfiedReason.highPrice' | transloco }}
          }
          @case ('INTRANSPARENT') {
            {{ 'cockpit.parseRequests.createGeneral.unsatisfiedReason.intransparent' | transloco }}
          }
          @case ('OTHER') {
            {{
              parseRequest().unsatisfiedOtherReason ||
                'cockpit.parseRequests.createGeneral.unsatisfiedReason.other' | transloco
            }}
          }
        }
      </span>
    </div>
  </div>
  <!-- files -->
  <div class="flex flex-col gap-2 text-on-surface dark:text-on-surface-darkmode text-sm">
    <h3 class="font-semibold leading-6 line-clamp-2">
      {{ 'cockpit.parseRequests.details.general.filesTitle' | transloco }}
    </h3>
    <ul class="border border-outline dark:border-outline-darkmode rounded-lg">
      @for (file of parseRequest().files; track file.id; let last = $last) {
        <li
          class="flex gap-4 items-center p-4 border-outline dark:border-outline-darkmode"
          [class.border-b]="!last"
        >
          <div class="flex-none text-on-surface-variant dark:text-on-surface-variant-darkmode">
            <ng-icon name="heroPaperClip" size="20" class="!block" />
          </div>
          <div class="flex-1 text-sm leading-6 line-clamp-1">
            {{ file.filename }}
          </div>
          <a
            [href]="file.id | fileUrl: organizationId()"
            target="_blank"
            class="flex-none text-primary dark:text-primary-darkmode hover:underline"
          >
            {{ 'cockpit.parseRequests.details.general.viewDownloadLink' | transloco }}
          </a>
        </li>
      }
    </ul>
  </div>
</div>
